import { toast } from 'sonner';

import { useFavoriteAccountIds, useToggleFavorite } from '@/lib/query/hooks';

/** アカウント選択リストのお気に入り（ホーム画面のアカウント一覧と同じものを共有する）。 */
export function useAccountFavorites() {
  // 取得に失敗してもアカウントは選べるため、お気に入り無しとして扱う
  const { data: favoriteAccountIds = [] } = useFavoriteAccountIds();
  const toggle = useToggleFavorite();

  const toggleFavorite = (accountId: string, shouldBeFavorite: boolean) => {
    toggle.mutate(
      { accountId, shouldBeFavorite },
      {
        onError: (error) =>
          toast.error(
            `お気に入りを更新できませんでした: ${error instanceof Error ? error.message : String(error)}`,
          ),
      },
    );
  };

  return { favoriteAccountIds, toggleFavorite };
}
